export { formatDate } from "@/util/date";

export const formatLanguages = function (languages) {
    return languages
      .map(lang => {
        const languageName = new Intl.DisplayNames([lang], { type: 'language' });
        return languageName.of(lang);
      })
      .join(', ');
  };

export const formatStatus = function (status) {
    switch (status) {
        case 'TODO':
            return 'To be translated'
        case 'IN_PROGRESS':
            return 'Processing'
        case 'DONE':
            return 'Translated'
    }
}

export const formatLanguagesEnglish = function (languages) {
  return languages
    .map(lang => {
      const languageName = new Intl.DisplayNames(["en"], { type: 'language' });
      return languageName.of(lang);
    })
    .join(', ');
};
